import ArrowBottom from "assets/svg/arrow-bottom.svg";
import React, { FC } from "react";

import style from "./styles.module.css";

type Props = {
  title: string;
  detailsClass?: string;
};

const Details: FC<Props> = ({ title, detailsClass, children }) => {
  return (
    <details
      className={`${style.details} border-b border-[#B8B7B7] text-xs md:text-sm ${detailsClass}`}
    >
      <summary className={`${style.summary}`}>
        <div className="flex w-full justify-between">
          <div className="flex">
            <span className="text-xs">{title}</span>
          </div>
          <div className="flex">
            <ArrowBottom className={style.arrow} />
          </div>
        </div>
      </summary>
      <ul className="space-y-[10px] pt-2 text-[10px]">{children}</ul>
    </details>
  );
};

export default Details;
